import { bindActionCreators, compose } from 'redux';
import { Clickable, Col, FullScreenHeader, H2, H3, Hidden, Image, P, Row, TypeWrapper, Wrapper } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';

import { RootState } from '../../reducers';
import AllProductsDataLoader from '../../components/all-products-data-loader';
import cakeImage from './images/41-cake.svg';
import constants from '../../ahm-constants';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import loadPriceForComponentProps from '../../models/price/load-price-for-component-props';
import moneyFlyingImage from './images/money-flying.svg';
import moneyPocketImage from './images/money-pocket.svg';
import moneyWaveImage from './images/money-wave.svg';
import phoneImage from '../../images/phone.svg';
import PriceActions from '../../actions/price';
import selectCustomer from '../../selectors/select-customer';
import SliderBox from './components/slider-box';
import styles from './styles.module.sass';
import youthDiscountGroupImage from './images/youth-discount-group.svg';

class YouthDiscountPage extends PureComponent {
  // @ts-expect-error - Automatic, Please fix when editing this file
  componentDidMount() {
    // @ts-expect-error - Automatic, Please fix when editing this file
    loadPriceForComponentProps.componentDidMount(this.props);
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  componentDidUpdate(prevProps) {
    loadPriceForComponentProps.componentWillReceiveProps(prevProps, this.props);
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  render() {
    return (
      <LegacyBorderedWrapper>
        <Head>
          <title>Youth discount | Health insurance for young adults</title>
          <meta
            name="description"
            content="Aged 18-29 years old? You could be eligible for a discount on hospital cover. Learn more about Health Insurance for young adults with ahm today."
          />
        </Head>
        <div>
          <FullScreenHeader
            title={
              <>
                Youth Discount <br />
                is here
              </>
            }
            subtitle={
              <>
                If you’re aged 18 – 29 and a Principal member or partner, you can get a discount on your hospital cover.
              </>
            }
            scrollToElementId="benefits"
            scrollToElementText="The ins and outs of the youth discount"
          />

          <div id="benefits">
            <TypeWrapper variant={['simpleBit', 'center']}>
              <Wrapper className={styles.benefits}>
                <H2 variant="marginBottomSpacer7">So, how do I get the Youth Discount?</H2>
                <Row>
                  <Col variant={styles.singleBenefit} df={4} lg={4} sm={12}>
                    <div className={styles.image}>
                      <Image src={phoneImage.src} role="presentation" />
                    </div>
                    <H3 looksLike="h4">Choose any hospital product</H3>
                    <P variant={styles.benefitContent}>You’ll find the discount on any ahm hospital product</P>
                  </Col>
                  <Col variant={styles.singleBenefit} df={4} lg={4} sm={12}>
                    <div className={styles.image}>
                      <Image src={moneyWaveImage.src} role="presentation" />
                    </div>
                    <H3 looksLike="h4">Pocket the savings</H3>
                    <P variant={styles.benefitContent}>You could save on the hospital component of your premium</P>
                  </Col>
                  <Col df={4} lg={4} sm={12}>
                    <div className={styles.image}>
                      <Image src={cakeImage.src} role="presentation" />
                    </div>
                    <H3 looksLike="h4">Keep saving</H3>
                    <P variant={styles.benefitContent}>
                      Keep continuous hospital cover and maintain the discount until you turn 41
                    </P>
                  </Col>
                </Row>
              </Wrapper>
            </TypeWrapper>
          </div>
          <SliderBox />

          <Wrapper className={styles.additionalInfo}>
            <div className={styles.singleAdditionalInfo}>
              <H2 looksLike="h3" variant="marginBottomSpacer9">
                How does the Youth Discount work?
              </H2>
              <P>The Youth Discount helps make private health insurance for young adults more affordable.</P>
              <P>
                So, if you’re a young adult aged 18 – 29 and a Principal Member or partner, you can get a discount on
                your ahm hospital cover, or the hospital part of a health insurance package.
              </P>
              <P>
                Plus, if you keep your hospital cover, the Youth Discount will continue to apply until you turn 41.
                Basically, the sooner you join ahm before you turn the big 3-0 the more you could save on hospital
                cover.
              </P>
              <P>
                <Clickable to={constants.URLS.HELP.YOUTH_DISCOUNT}>
                  Learn how the youth discount is calculated.
                </Clickable>
              </P>
            </div>
            <Hidden xs sm md>
              <Image src={moneyPocketImage.src} role="presentation" className={styles.imageRight} />
              <Image src={moneyFlyingImage.src} role="presentation" className={styles.imageBottomLeft} />
            </Hidden>
            <div className={styles.singleAdditionalInfo}>
              <H2 looksLike="h3" variant="marginBottomSpacer9">
                Stick with us and your discount will be ongoing
              </H2>
              <Image src={youthDiscountGroupImage.src} role="presentation" className={styles.youthDiscountGroupImage} />
              <P>
                If you maintain continuous hospital cover, the Youth Discount you get when you first become eligible
                will stay the same every year until you turn 41.
              </P>
              <P>It then reduces by 2% every year on your birthday and until it gets to zero.</P>
              <P>
                For example, if you first take out hospital cover when you’re 26, you’ll keep the 8% discount until
                you’re 41 if you maintain hospital cover. Then it will decrease by 2% each year on your birthday until
                the discount has been removed.
              </P>
            </div>
            <div className={styles.singleAdditionalInfo}>
              <H2 looksLike="h3" variant="marginBottomSpacer9">
                Transferring from another fund?
              </H2>
              <P>
                If you’re switching to ahm from another fund with a Youth Discount applied to your hospital product, you
                may be able to transfer the Youth Discount with you.
                <br />
                <Clickable to={constants.URLS.SALES.FIND_HEALTH_INSURANCE}>Switch to us now.</Clickable>
              </P>
            </div>
            <H2 looksLike="h3" variant="marginBottomSpacer9">
              Need help?
            </H2>
            <P>
              Our <Clickable to={constants.URLS.HELP.YOUTH_DISCOUNT}>Help</Clickable> and support pages can answer some
              pretty detailed questions, but if you’d prefer to chat to a human,{' '}
              <Clickable to={constants.URLS.SALES.CONTACT_US}>contact us</Clickable>
            </P>
          </Wrapper>
        </div>
      </LegacyBorderedWrapper>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  customer: selectCustomer(state),
  prices: state.price.data,
  products: state.product.data,
});

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    price: bindActionCreators(PriceActions, dispatch),
  },
});

export default compose(AllProductsDataLoader, connect(mapStateToProps, mapDispatchToProps))(YouthDiscountPage);

export { YouthDiscountPage as YouthDiscountPageForTest, mapStateToProps };
